// extracted by mini-css-extract-plugin
export default {"where":"conferenceDetails_where__dVJ5O"};